<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('notifications.create')" @invoke-method="invokeMethod($event)" action="openNotificationForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetNotifications(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <bc-autocomplete
                                            v-model="filter.people_id"
                                            :label="`${$t('lang.person')}`"
                                            :initial="filter.people_id"
                                            :items="people"
                                            item-value="people_id"
                                            item-text="combined_name"
                                            prepend-icon="account_box"
                                        ></bc-autocomplete>
                                    </v-list-tile>

                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="notifications" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr
                                class="clickable"
                                @mouseup.left="openNotificationForm(props.item)"
                                :class="{ 'grey lighten-5': props.item.notification_id % 2 === 0, 'grey lighten-3': props.item.notification_id % 2 !== 0 }"
                            >
                                <td>
                                    <span
                                        ><v-icon>{{ props.item.notify_type }}</v-icon></span
                                    >
                                </td>
                                <td>{{ props.item.notification_id }}</td>
                                <td>{{ props.item.notify_place }}</td>
                                <td>{{ props.item.full_name }}</td>
                                <td>{{ props.item.subject }}</td>
                                <td>{{ props.item.object_name }}</td>
                                <td>{{ props.item.object_id }}</td>
                                <td class="text-center">
                                    <span
                                        ><v-icon :color="props.item.modal_class">{{ props.item.modal_icon }}</v-icon></span
                                    >
                                </td>
                                <td class="text-center">
                                    <span v-if="props.item.icon"
                                        ><v-icon :color="props.item.icon_class">{{ props.item.icon }}</v-icon></span
                                    >
                                </td>
                                <td>{{ props.item.date_created }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="notifications"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="notification_dialog" :scrollable="false" fullscreen>
                <v-card>
                    <v-form ref="form_notification">
                        <v-card-title>
                            <span class="headline">{{ notification.notification_id ? $t("lang.edit_notification") : $t("lang.add_notification") }}</span>
                            <v-spacer horizontal></v-spacer>

                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeNotificationDialog"
                                :dialog-status="notification_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-container grid-list-xl>
                            <v-layout row :wrap="!$bp.lgAndUp">
                                <v-flex xs12 md3 lg2>
                                    <v-layout column>
                                        <bc-search-list
                                            :items="current_user.accounts"
                                            selected_id=""
                                            filter=""
                                            clickMethod=""
                                            item-value="company_id"
                                            item-text="company"
                                            height="210px"
                                            emptyMessage=""
                                        ></bc-search-list>
                                    </v-layout>
                                </v-flex>

                                <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>

                                <v-flex xs12 md9 lg10>
                                    <v-layout row wrap>
                                        <v-flex xs10>
                                            <v-text-field
                                                v-focus="notification_dialog"
                                                v-model="notification.notification_id"
                                                :label="$t('lang.notification_id')"
                                                :counter="showCounter(notification.notification_id, 'notifications.notification_id')"
                                                :rules="ifValid('notifications.notification_id')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs2>
                                            <v-switch
                                                v-model="notification.modal"
                                                :label="`${notification.modal == 1 ? $t('lang.modal') : $t('lang.non_modal')}`"
                                                true-value="1"
                                                false-value="0"
                                            >
                                            </v-switch>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="notification.subject"
                                                :label="$t('lang.subject')"
                                                :counter="showCounter(notification.subject, 'notifications.subject')"
                                                :rules="ifValid('notifications.subject')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-if="!notification.notification_id"
                                                style="padding-top: 0px !important"
                                                :value="notification.message"
                                                :label="`${$t('lang.message')} *`"
                                                hide-details
                                                outline
                                                scroll
                                                rows="20"
                                                :rules="ifValid('notifications.message')"
                                            ></v-textarea>
                                            <div v-else v-html="notification.message"></div>
                                        </v-flex>
                                        <v-flex xs12 md6 lg4>
                                            <bc-select
                                                v-model="notification.icon"
                                                :label="`${$t('lang.icon')} *`"
                                                :items="notification_icons"
                                                :propsMenu="{ top: true }"
                                                :rules="ifValid('notifications.icon')"
                                            >
                                                <template slot="item" slot-scope="data">
                                                    <v-icon :color="notification.icon_class" class="mr-2">{{ data.item.value }}</v-icon
                                                    ><span>{{ data.item.option }}</span>
                                                </template>
                                                <template slot="selection" slot-scope="data">
                                                    <v-icon :color="notification.icon_class" class="mr-2">{{ data.item.value }}</v-icon
                                                    ><span>{{ data.item.option }}</span>
                                                </template>
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs12 md6 lg4>
                                            <bc-select
                                                v-model="notification.object_name"
                                                :label="`${$t('lang.object_name')}`"
                                                :items="notification_object_names"
                                                :propsMenu="{ top: true }"
                                                :rules="ifValid('notifications.object_name')"
                                                item-value="value"
                                                item-text="option"
                                                @change="notification.object_id = ''"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs12 md6 lg4>
                                            <v-text-field
                                                v-model="notification.file"
                                                :label="$t('lang.file')"
                                                :counter="showCounter(notification.file, 'notifications.file')"
                                                :rules="ifValid('notifications.file')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md6 lg4>
                                            <bc-select
                                                v-model="notification.icon_class"
                                                :label="`${$t('lang.icon_class')} *`"
                                                :items="notification_icon_classes"
                                                :propsMenu="{ top: true }"
                                                :rules="ifValid('notifications.icon_class')"
                                            >
                                                <template slot="item" slot-scope="data">
                                                    <v-icon :color="data.item.value" class="mr-2">square</v-icon><span>{{ data.item.option }}</span>
                                                </template>
                                                <template slot="selection" slot-scope="data">
                                                    <v-icon :color="data.item.value" class="mr-2">square</v-icon><span>{{ data.item.option }}</span>
                                                </template>
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs12 md6 lg4>
                                            <v-text-field
                                                v-if="notification.object_name != '' && notification.object_name != null"
                                                v-model="notification.object_id"
                                                :label="$t('lang.object_id')"
                                                :counter="showCounter(notification.object_id, 'notifications.object_id')"
                                                :rules="ifValid('notifications.object_id')"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                    <v-card-actions>
                        <v-btn v-if="notification.notification_id" color="error" @mouseup.left="$refs.delete_notifications.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeNotificationDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveNotifications">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_notifications"
                :heading="$t('lang.delete_notification')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteNotifications(notification.notification_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openNotificationForm" },
                { title: this.$t("lang.refresh"), action: "dbGetNotifications", params: [true] },
            ],
            headers: [
                { sortable: false, width: "2%" },
                { text: this.$t("lang.notification_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.notify_place"), sortable: false, width: "15%" },
                { text: this.$t("lang.name"), sortable: false, width: "25%" },
                { text: this.$t("lang.subject"), sortable: false, width: "15%" },
                { text: this.$t("lang.object_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.object_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.modal"), align: "center", sortable: false, width: "10%" },
                { text: this.$t("lang.icon"), align: "center", sortable: false, width: "5%" },
                { text: this.$t("lang.date_sent"), align: "center", sortable: false, width: "5%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            notification: { icon_class: "primary", icon: "notifications", object_name: "" },
            filter: {
                search: "",
                people_id: "",
                status: "",
            },
            notification_dialog: false,
            dbGetNotifications: _.debounce(this.getNotifications, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (to.path.includes("me")) {
            store
                .dispatch("fetchMeNotifications", {
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notifications) {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            store
                .dispatch("fetchNotifications", {
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.notifications) {
                        next((vm) => {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (to.path.includes("me")) {
            this.fetchMeNotifications({
                body: parsedQuery,
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.notification_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(false);
                    next();
                });
        } else {
            this.fetchNotifications({
                body: parsedQuery,
                body: parsedQuery,
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.notification_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(false);
                    next();
                });
        }
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.notifications.notifications_filter,
            page: (state) => state.notifications.notifications_page,
            rules_notifications: (state) => state.notifications.rules_notifications,
            notification_status_options: (state) => state.settings.notification_status_options,
            notifications: (state) => state.notifications.notifications,
            people: (state) => state.people.person_options,
            notification_icon_classes: (state) => state.options_categories.notification_icon_classes,
            notification_icons: (state) => state.options_categories.notification_icons,
            notification_object_names: (state) => state.options_categories.notification_object_names,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchNotifications", "saveNotification", "deleteNotification", "fetchMeNotifications", "fetchPeople", "fetchOptions"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openNotificationForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_notification) item ? this.$refs.form_notification.resetValidation() : this.$refs.form_notification.reset();

                    this.$nextTick(() => {
                        this.notification = item != null ? this.assignObj2(item, this.rules_notifications) : {};
                        this.notification_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "notification", params: { id: item.notification_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_notification) item ? this.$refs.form_notification.resetValidation() : this.$refs.form_notification.reset();
                    this.$nextTick(() => {
                        this.notification = { icon_class: "primary", icon: "notifications", object_name: "" };
                        this.notification_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "notification" });
                }
            }
        },
        saveNotifications() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_notification")) {
                    let body = this.prepForm(this.notification, this.rules_notifications);

                    this.saveNotification({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getNotifications();
                                this.closeNotificationDialog();
                            } else {
                                this.$router.push({ name: "notification", params: { id: data.notification_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteNotifications(id = null) {
            this.deleteNotification({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getNotifications();
                    this.closeNotificationDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeNotificationDialog() {
            this.notification_dialog = false;
            this.$refs.delete_notifications.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getNotifications(pg_refresh = false) {
            this.startLoader();

            if (this.$route.path.includes("me")) {
                this.fetchMeNotifications({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.notification_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(pg_refresh);
                    });
            } else {
                this.fetchNotifications({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.notification_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(pg_refresh);
                    });
            }
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getPeople() {
            this.fetchPeople({ body: { options: 1, has_user_account: 1 } });
        },
    },
    mounted() {
        this.getPeople();
        if (this.notification_icon_classes.length == 0) this.fetchOptions({ body: { slug: "notification_icon_classes" } });
        if (this.notification_icons.length == 0) this.fetchOptions({ body: { slug: "notification_icons" } });
        if (this.notification_object_names.length == 0) this.fetchOptions({ body: { slug: "notification_object_names", sort_by: 1 } });
    },
};
</script>
